<script>
import form from '@/utils/form';
import { units, materialStatus } from '@/utils/enum';

import AvatarEditable from '@/components/AvatarEditable.vue';
import BaseField from '@/components/BaseField.vue';
import MaterialCategorySelector from '@/components/exchange/material/MaterialCategorySelector.vue';
import RadioList from '@/components/base/RadioList.vue';
import MaterialRoomList from '@/components/exchange/material/MaterialRoomList.vue';
import FileUploaderSingle from '@/components/file/FileUploaderSingle.vue';

export default {
  name: 'MaterialForm',
  components: {
    FileUploaderSingle,
    MaterialRoomList,
    RadioList,
    MaterialCategorySelector,
    BaseField,
    AvatarEditable,
  },
  controller: null,
  props: {
    categories: Array,
    project: Object,
  },
  data() {
    return {
      isOpened: false,
      item: null,
      avatar: null,
      file: null,
      category: null,
      delivery: '',
      assembly: '',
      rooms: [],
      /* eslint-disable */
      form: {
        name: form.createFieldObject('string', '', ''),
        volume: form.createFieldObject('float', '', ''),
        volumeUnit: form.createFieldObject('select', '', null, {}, units.volume),
        budget: form.createFieldObject('float', '', ''),
        budgetCurrency: form.createFieldObject('select', '', 'rur', {}, units.currency),
        status: form.createFieldObject('select', '', null, {}, materialStatus),
        deadlineAt: form.createFieldObject('date', '', null, {}, { no: 'Нет', door: 'До двери', building: 'До здания' }),
        description: form.createFieldObject('textarea', '', ''),
      },
      /* eslint-enable */
    };
  },
  computed: {
    projectRooms() {
      return (this.project?.objectRooms?.rooms ?? []).map(r => r.name);
    },
  },
  methods: {
    open(item) {
      this.isOpened = true;

      if (item) {
        this.item = item;
        form.setValues(this.form, item);
        this.category = item.category?.['@id'] ?? null;
        this.avatar = item.avatar;
        this.file = item.file;
        this.delivery = item.delivery;
        this.assembly = item.assembly;
        this.rooms = item.rooms;
      }

      document.body.style.overflow = 'hidden';
      return new Promise((resolve, reject) => {
        this.$options.controller = { resolve, reject };
      });
    },
    close(result) {
      this.isOpened = false;
      form.clear(this.form);
      this.category = null;
      this.avatar = null;
      this.file = null;
      this.delivery = '';
      this.assembly = '';
      this.rooms = [];
      // не 'auto': оно ломает position: sticky на странице (см. router/index.js)
      document.body.style.removeProperty('overflow');
      this.$options.controller.resolve(result);
    },
    async save() {
      const data = form.getValues(this.form);
      data.category = this.category;
      data.project = this.project['@id'];
      data.avatar = this.avatar?.['@id'] ?? null;
      data.file = this.file?.['@id'] ?? null;
      data.delivery = this.delivery;
      data.assembly = this.assembly;
      data.rooms = this.rooms;
      this.close(data);
    },
  },
};
</script>

<template lang="pug">
.material-form(v-if="isOpened")
  .wrap
    button.close(@click="close()")
    .title(v-if="item") Редактировать материал
    .title(v-else) Добавить материал
    .block
      .subtitle Изображение материала
      AvatarEditable(:avatar="avatar" @change="avatar = $event")
    .block
      .subtitle Наименование
      BaseField(v-model="form.name.value" v-bind="form.name")
    .block
      .subtitle Выберите категорию
      MaterialCategorySelector(:items="categories" v-model="category")
    .block
      .subtitle Количество материала
      .with-unit
        BaseField(v-model="form.volume.value" v-bind="form.volume")
        BaseField(v-model="form.volumeUnit.value" v-bind="form.volumeUnit")
    .block
      .subtitle Бюджет
      .with-unit
        BaseField(v-model="form.budget.value" v-bind="form.budget")
        BaseField(v-model="form.budgetCurrency.value" v-bind="form.budgetCurrency")
    .block
      .subtitle Доставка
      RadioList(withOwn v-model="delivery" :items="['С доставкой', 'Без доставки', 'С доставкой и подъемом']")
    .block
      .subtitle Монтаж
      RadioList(withOwn v-model="assembly" :items="['С монтажом', 'Частичный монтаж', 'Без монтажа']")
    .block
      .subtitle Помещения
      MaterialRoomList(:items="projectRooms" v-model="rooms")
    .block
      .subtitle Статус
      BaseField(v-model="form.status.value" v-bind="form.status")
    .block
      .subtitle Срок
      BaseField(v-model="form.deadlineAt.value" v-bind="form.deadlineAt")
    .block
      FileUploaderSingle(:file="file" @change="file = $event")
    .block
      .subtitle Описание
      BaseField(v-model="form.description.value" v-bind="form.description")
    .buttons
      Btn(grey @click="close") Отмена
      Btn(@click="save") Сохранить
</template>

<style scoped lang="scss">
.material-form {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10000;

  &:before {
    display: block;
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
  }
}

.close {
  position: absolute;
  width: 36px;
  height: 36px;
  background: #EBEFF2;
  top: 66px;
  right: 45px;
  cursor: pointer;
  border-radius: 100%;

  &:before, &:after {
    content: '';
    display: block;
    position: absolute;
    width: 1px;
    height: 20px;
    background: #C4C4C4;
    top: 8px;
    left: 18px;
  }

  &:after { transform: rotate(-45deg); }
  &:before { transform: rotate(45deg); }
}

.wrap {
  box-sizing: border-box;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 750px;
  background: #FFFFFF;
  padding: 55px;
  overflow: auto;
}

.block {
  margin-bottom: 40px;
}

.title {
  font-size: 36px;
  font-weight: 700;
  line-height: 56px;
  color: #1E3147;
  margin-bottom: 30px;
}

.subtitle {
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: #788CA1;
  margin-bottom: 20px;
}

.with-unit {
  display: flex;
  gap: 7px;

  :nth-child(2) {
    width: 70px;
  }
}

.buttons {
  display: flex;
  gap: 30px;
  justify-content: flex-end;
}

</style>
